import { api } from "../api";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import uploadIcon from "../assets/upload-icon.svg";

const Update = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [book, setBook] = useState({
    title: "",
    authors: "",
    genre: "",
    desc: "",
  });

  const [genres, setGenres] = useState([]);

  const [file, setFile] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  const bookId = location.pathname.split("/")[2];

  console.log(location.pathname.split("/")[2]);

  const handleChange = (e) => {
    setBook((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    const fetchBook = async () => {
      try {
        const res = await api.get(`/books/${bookId}`);
        setBook({
          title: res.data.title ?? "",
          authors: res.data.authors ?? "",
          genre: res.data.genre ?? "",
          desc: res.data.desc ?? "",
        });
      } catch (err) {
        console.error(err);
      }
    };

    fetchBook();
  }, [bookId]);

  useEffect(() => {
    const fetchGenres = async () => {
      try {
        const res = await api.get("/genres");
        setGenres(res.data);
      } catch (err) {
        console.error("Failed to load genres", err);
      }
    };

    fetchGenres();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!book.title.trim() || !book.authors.trim()) {
      setError("Title and Authors are required");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("title", book.title);
      formData.append("authors", book.authors);
      formData.append("genre", book.genre);
      formData.append("desc", book.desc);

      // Only append cover if user selected a new one
      if (file) {
        formData.append("cover", file);
      }

      await api.put(`/books/${bookId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      navigate("/my-books");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  console.log(book);

  return (
    <div className="page">
      <main className="page-content">
        <div className="form-card">
          <form className="form" onSubmit={handleSubmit}>
            <h1>UPDATE THIS BOOK!</h1>

            {error && <div className="form-error">{error}</div>}

            <input
              type="text"
              name="title"
              value={book.title}
              onChange={handleChange}
              placeholder="Add title..."
              required
            />

            <input
              type="text"
              name="authors"
              value={book.authors}
              onChange={handleChange}
              placeholder="Add author(s)..."
              required
            />

            <label>
              <select
                name="genre"
                value={book.genre}
                onChange={handleChange}
                required
              >
                <option value="">Select a genre</option>
                {genres.map((g) => (
                  <option key={g} value={g}>
                    {g.charAt(0).toUpperCase() + g.slice(1)}
                  </option>
                ))}
              </select>
            </label>

            <input
              type="text"
              placeholder="Description"
              name="desc"
              value={book.desc}
              onChange={handleChange}
            />

            <label className="upload-btn">
              <img src={uploadIcon} alt="Upload" />
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setFile(e.target.files[0])}
                hidden
              />
            </label>

            <button type="submit" className="formButton" disabled={loading}>
              {loading ? "Updating..." : "Update"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default Update;
